import { useEffect } from 'react'
import { getIn, useFormikContext } from 'formik'

/**
 * Copies one Formik value to another key whenever it changes. The Add Lead selects this modal
 * reuses write Add Lead's own keys (`leadSourceId`, `targetPests`, `state`); the modal's form model
 * uses `sourceId`, `targetPestIds` and `stateAbbreviation`, so the value is mirrored across.
 */
export function useMirrorFormValue(fromKey: string, toKey: string) {
  const { values, setFieldValue } = useFormikContext<object>()
  const value = getIn(values, fromKey)
  const current = getIn(values, toKey)

  useEffect(() => {
    if (value !== undefined && value !== current)
      setFieldValue(toKey, value, false)
  }, [value, current, toKey, setFieldValue])
}
